export default {
  title: {
    id: 'buyback_refurbisher_on_hold_modal_title',
    defaultMessage: 'What do you want to do next?',
  },
  description: {
    id: 'buyback_refurbisher_on_hold_modal_description',
    defaultMessage:
      'Once you’ve received the item, you have 2 business days to take 1 of the following actions:',
  },
  requiredErrorMessage: {
    id: 'buyback_refurbisher_on_hold_modal_on_hold_reasons_error_message',
    defaultMessage: 'Please select at least one reason',
  },
}
